// SafiGlow — SafiCalm-style calm motion (draft only).
// Gentle scroll reveal only. No flashing, no slow motion, no video changes.
(function () {
  // Mark JS as running BEFORE hiding anything, so a JS failure
  // never leaves homepage sections invisible (CSS only hides
  // .sg-reveal when .sg-calm-js is present).
  document.documentElement.classList.add('sg-calm-js');

  function initReveal() {
    var items = document.querySelectorAll('.sg-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
